import request from '@/utils/httpRequest'

export default class ArchiveTypeService {
    queryById(id) {
        return request({
            url: '/archive/wuyeArchiveType/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/archive/wuyeArchiveType/startFlow',
            method: 'post',
            data: params
        })
    }

}
